import getCommonAttributes from 'modules/addons/components/digital-onboarding/PPSRRegistration/forms/versionAttributes/commonAttributes';
import isPresent from 'utils/isPresent';

export default class AUVersionAttributes {
  static getNewVersionConfigAttribute(addonConfig, data) {
    const attributes = getCommonAttributes(addonConfig, data);

    return {
      ...attributes,
      functions: {
        discharge: data.functionDischarge,
        modify: data.functionModify,
        register_eight_to_twenty_five: data.functionRegisterEightToTwentyFive,
        register_no_end_time: data.functionRegisterNoEndTime,
        register_zero_to_seven_years: data.functionRegisterZeroToSevenYears,
        renew: data.functionRenew,
      },
    };
  }

  static getDefaultConfigValues(currentEntity, newVersion) {
    const config = newVersion.config;

    if (isPresent(config)) {
      return config;
    }

    return {
      collateral_preset: {
        AGR: { active: false, description: '' },
        FIN: { active: false, description: '' },
        GEN: { active: false, description: '' },
        INT: { active: false, description: '' },
        OTH: { active: false, description: '' },
      },
      financing: {
        auto_renew: false,
      },
      functions: {
        discharge: false,
        modify: false,
        register_eight_to_twenty_five: false,
        register_no_end_time: false,
        register_zero_to_seven_years: false,
        renew: false,
      },
      secured_party_group: {
        organisation: {
          email: currentEntity.keyContactEmail,
          name: currentEntity.tradingName,
          phone: currentEntity.keyContactPhoneNumber,
        },
        person: {
          first_name: currentEntity.keyContactFirstName,
          last_name: currentEntity.keyContactLastName,
        },
      },
    };
  }
}
